module.exports = __webpack_public_path__ + "img/h_product_29.328adf4.jpg";